module.exports = __webpack_public_path__ + "static/img/nav11.222f90d0.svg";